import { Box, Typography, Select, MenuItem } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import DataListingComponent from "../../Component/DataListingComponent";
import view from "../../Assets/View.png";
import BookingDetailsModal from "../BookingDetails/BookingDetailsModal";
import { API_endspoints } from "../../API/API_endspoints";
import { API_GET } from "../../API/config";
import moment from "moment";

const PAGE_SIZE_OPTIONS = [15];
const STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: 0, label: "Pending" },
  { value: 1, label: "Booked" },
  { value: -1, label: "Cancelled" },
];

const BookingManagement = () => {
  const [data, setData] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");

  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowid",
      headerName: "Sr.",
      width: 50,
      headerAlign: "center",
    },
    // {
    //   headerClassName: "super-app-theme--header",
    //   field: "id",
    //   headerName: "ID",
    //   width: 50,
    //   headerAlign: "center",
    // },
    {
      headerClassName: "super-app-theme--header",
      field: "userName",
      headerName: "User Name",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        return cell?.row?.user_details?.full_name;
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "company_details",
      headerName: "Company Name",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        return cell?.row?.company_details?.company_name;
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "from_date",
      headerName: "From Date",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => moment(cell?.row?.from_date).format('ll') ?? '-',
    },
    {
      headerClassName: "super-app-theme--header",
      field: "to_date",
      headerName: "To Date",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => moment(cell?.row?.to_date).format('ll') ?? '-',
    },
   
    {
      headerClassName: "super-app-theme--header",
      field: "bookingStatus",
      headerName: "Booking Status",
      width: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        const { booking_status } = cell?.row;
        // const handleStatusChange = (event) => {
        //   const newStatus = event.target.value;
        // };

        return (
          <Box className="flexCenter" sx={{ height: "100%" }}>
            {booking_status === 0 ? (
              <span style={{ color: "orange" }}>Pending</span>
            ) : booking_status === 1 ? (
              <span style={{ color: "green" }}>Booked</span>
            ) : (
              booking_status === -1 && (
                <span style={{ color: "red" }}>Cancelled</span>
              )
            )}
          </Box>
        );
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "is_Active",
      headerName: "View",
      width: 200,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              onClick={() => {
                setOpen(true);
                setModalData({
                  ...cell.row,
                  clickedFrom: 1
                });
              }}
              className="ImgHover"
              src={view}
              alt="icon"
              height={24}
              width={24}
            />
          </Box>
        </Box>
      ),
    },
  ];

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const getData = async (
    page = 0,
    pageSize = PAGE_SIZE_OPTIONS[0],
    status = "",
    statusRef = ""
  ) => {
    try
    {
      setIsLoading(true);
      let newPage = page;

      if (status !== statusRef)
      {
        newPage = 0;
        setPage(0);
      }
      let queryParams = new URLSearchParams({
        count: newPage * pageSize,
        offset: pageSize,
      });
      if (status !== "")
      {
        queryParams.append("booking_status", status);
      }

      const api = `${API_endspoints.GetBookingList}?${queryParams.toString()}`;
      let res = await API_GET(api);
      const Rowdata = res?.r?.map((data, i) => ({
        rowid: i + 1 + page * rowsPerPage,
        ...data,
      }));
      if (res?.r?.length > 0)
      {
        setData(Rowdata);
        setTotalData(res?.c ?? 0);
      } else
      {
        setData([]);
        setTotalData(0);
      }
      setIsLoading(false);
    } catch (error)
    {
      setIsLoading(false);
      console.log(error);
    }
  };

  const handleStatusChange = (event) => {
    const status = event.target.value;
    setSelectedStatus(status);
  };
  const statusRef = useRef(selectedStatus);

  useEffect(() => {
    getData(page, rowsPerPage, selectedStatus, statusRef.current);
    statusRef.current = selectedStatus;
  }, [page, rowsPerPage, selectedStatus]);

  return (
    <Box sx={{ height: "calc(100vh - 32px)" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
        }}
      >
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 500,
          }}
        >
          Booking Management
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1, // Adds spacing between label and dropdown
          }}
        >

          <Select
            value={selectedStatus}
            onChange={handleStatusChange}
            displayEmpty
            size="small"
            sx={{
              minWidth: 150, // Increased width for better usability
              padding: "4px 12px", // Padding to make the dropdown feel more spacious
              fontSize: "14px", // Font size for dropdown items
              borderRadius: "8px", // Smooth edges
              border: "1px solid #CED7E4", // Light border
              backgroundColor: "#F9F9F9", // Soft background color
              "&:hover": {
                backgroundColor: "#F0F0F0", // Hover effect for better interactivity
              },
            }}
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 130px)",
          width: "100%",
          p: 2,
        }}
      >
        <DataListingComponent
          data={data ?? []}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={IsLoading}
          totalData={totalData}
          page={page}
          Footer={true}
          columns={column}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
        <BookingDetailsModal open={open} setOpen={setOpen} data={modalData} />
      </Box>
    </Box>
  );
};

export default BookingManagement;
